module.exports = __webpack_public_path__ + "img/centre.0e03596.svg";